import { styled as styledMui } from '@mui/material/styles';
import { Paper } from '@mui/material';

export const CustomPaper = styledMui(Paper)(() => ({
	padding: '1rem',
}));
